module.exports = __webpack_public_path__ + "img/background-world-map.4df741df.svg";